import type { IYamlQueryTestResultData } from '../../../types';

export type TFormatSampleQueryMessage = (descriptor: {
  id: string;
}) => string;

/**
 * Sample 测试通过：将 query_test `data` 格式化为行内展示文案。
 */
export const formatSampleQueryResultText = (
  data: IYamlQueryTestResultData,
  formatMessage: TFormatSampleQueryMessage,
): string => {
  if (data.skipped) {
    return formatMessage({
      id: 'dbl_model_agent_step4_sample_skipped',
    });
  }

  const lines: string[] = [];

  if (data.time_dimension) {
    lines.push(
      `${formatMessage({
        id: 'dbl_model_agent_step4_sample_time_dimension',
      })}: ${data.time_dimension}`,
    );
  }

  if (data.date_range?.length) {
    lines.push(
      `${formatMessage({
        id: 'dbl_model_agent_step4_sample_date_range',
      })}: ${data.date_range.join(' ~ ')}`,
    );
  }

  if (data.measures_tested?.length) {
    lines.push(
      `${formatMessage({
        id: 'dbl_model_agent_step4_sample_measures',
      })}: ${data.measures_tested.join(', ')}`,
    );
  }

  if (data.total !== undefined && data.total !== null) {
    lines.push(
      `${formatMessage({
        id: 'dbl_model_agent_step4_sample_total',
      })}: ${data.total}`,
    );
  }

  if (data.query_sql?.trim()) {
    lines.push(
      `${formatMessage({
        id: 'dbl_model_agent_step4_sample_query_sql',
      })}:\n${data.query_sql.trim()}`,
    );
  }

  return lines.join('\n');
};
